import { Signal } from "@/data/util/Signal";

export const portalEvents = {
    // app context events
    OnLocationChanged: new Signal(),
};
